import React from 'react';
import { MUZOLOGY_APP } from '@/lib/defaults';
import SubmitButton from '@/components/Checkout/components/SubmitButton';
import Image from 'next/legacy/image';
import MainImage from '@/assets/CheckoutLoginReroute.png';
const CheckoutLoginReroute = () => {
    return (
        <div className='min-h-[960px] sm:min-h-[100%] bg-checkout-background-intro-mobile sm:bg-none pt-16 sm:pt-0 mt-[-54px] sm:mt-0'>
            <div className='shadow-checkout bg-white rounded-2xl sm:rounded-lg w-full py-6 max-w-[330px] tiny:max-w-[365px] sm:max-w-[600px] md:max-w-[700px] lg:max-w-[1000px] mx-auto mt-5 sm:mt-32 px-4 sm:px-0 font-Poppins '>
                <div className='font-semibold text-3xl lg:text-[45px] text-center mt-2 sm:mt-4'>Let's Go to the Login Page!</div>
                <div className='text-[#4E4E4E] font-normal text-lg lg:text-xl text-center mt-2 sm:mt-5'>You can go straight here by clicking Log In on the homepage.</div>
                <div className='mt-7 flex items-center justify-center '>
                    <div className=' hidden sm:block max-w-[565px] max-h-[264px]'>
                        <Image src={MainImage} className='max-w-full h-auto' />
                    </div>
                    <div className='max-w-[316px] max-h-[225px] h-auto block sm:hidden'>
                        <Image src={MainImage} className=' max-w-full h-auto' />
                    </div>
                </div>
                <div className='flex items-center justify-center mt-10'>
                    <SubmitButton
                        onClick={() => window.open(`${MUZOLOGY_APP}/login`)}
                        text='Continue'
                        className='h-11 sm:h-[58px]'
                    />
                </div>
            </div>
        </div>
    );
};

export default CheckoutLoginReroute;
